<template>
  <div>
    <callout
      apply-border-top
      :class="[studentRowColor]"
      :controlled="true"
      :has-border="false"
      has-gradient
      has-toggle
      :opened="value.isOpen"
      @click:open="showDetail"
    >
      <div class="row">
        <div
          class="col-12 col-md-4 align-items-center"
          :class="{
            'col-student': !isMobile,
            'pl-1': isMobile,
          }"
        >
          <div class="mt-4 font-14 d-flex justify-content-between">
            <span
              class="color-black"
              :class="{
                'font-weight-normal': !isMobile,
                'ml-1 font-weight-bold': isMobile,
              }"
            >
              {{ studentSieName }}
            </span>
            <div v-if="showViewErrors">
              <em class="fas fa-info-circle color-orange mr-2" />
              <span class="errors-link" @click="showErrors">
                Ver Errores
              </span>
            </div>
            <action-button
              :disabled="!value.hasPlan"
              i="fas fa-save ml-1"
              variant="success"
              @click="() => saveVisit(!value.hasPlan)"
            />
          </div>
        </div>
        <div
          :class="{
            'd-plex py-3 row col': !isMobile,
            'grid-7 w-100 mr-2': isMobile,
          }"
        >
          <div
            v-for="day in changeViewMode()"
            :key="day"
            :class="{
              col: !isMobile,
            }"
          >
            <i
              v-if="showVisitScheduleUpdatedIcon(day)"
              class="far fa-clock mr-1 visit-schedule-updated-icon"
              :class="{
                'text-success': visitScheduleUpdated(day),
              }"
              @click.stop="onClickUpdateSchedule(day)"
            />
            <vue-select
              :key="componentKey"
              class="col col-md-2 py-2 px-1"
              :class="{
                'select-assistence': !isMobile,
                'vue-select__extended': isMobile && getVisitType(day),
              }"
              :clearable="false"
              :disabled="disableDay(day) || !value.hasPlan"
              :options="assistenceType"
              :searchable="false"
              :value="getVisitType(day)"
              @input="setVisitType(day, $event)"
            >
              <template #selected-option="{ label }">
                <img
                  v-if="getAssistenceTypeItem(label).img"
                  :class="{ 'ml-3': showVisitScheduleUpdatedIcon(day) }"
                  :src="getAssistenceTypeItem(label).img"
                />
              </template>
              <template #option="{ label, img }">
                <img v-if="img" :src="img" />
                {{ label }}
              </template>
            </vue-select>
            <visit-calendar-schedule-update
              v-if="showVisitScheduleUpdatedComponent(day)"
              :data="visitScheduleSelected"
              :day="day"
              :duration="value.duration"
              :schedule-id="getSchedule(day).id"
              @cancel="onCancelScheduleUpdate"
              @save="onSaveScheduleUpdate"
            />
          </div>
        </div>
      </div>
      <template #edition>
        <div
          v-if="openAdsencePanel"
          class="row px-4 py-3 w-100"
          :class="isMobile && 'mx-0'"
        >
          <div class="col-12 d-flex">
            <i
              aria-hidden="true"
              class="fa fa-exclamation-circle text-orange mr-2 mt-1"
            />
            <p class="font-16 font-weight-bold">Informacion de Ausencias</p>
          </div>
          <div class="col-12">
            <validation-observer ref="formAbsense">
              <div class="row mb-2">
                <div class="col-12 col-md-4 mb-3 mb-lg-0">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-drop-down
                      v-model="modelAbsence.type"
                      custom-error-msg="El tipo de ausencia es requerido."
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      label="Tipo:"
                      :options="visitTypeAusencia"
                      placeholder="Seleccione"
                    />
                  </validation-provider>
                </div>
                <div class="col-12 col-md-4 mb-3 mb-lg-0">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-drop-down
                      v-if="showIfAusencia(modelAbsence)"
                      v-model="modelAbsence.justification"
                      custom-error-msg="La justificacion es requerida."
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      label="Justificacion:"
                      :options="justificationOptions"
                      placeholder="Seleccione"
                    />
                  </validation-provider>
                </div>
                <div v-if="requiresDocumentation" class="col-12 col-md-4">
                  <div class="data-name mb-2">
                    Documento de Justificacion de Ausencia:
                  </div>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-file-input
                      v-if="showIfAusencia(modelAbsence)"
                      ref="attachedDocument"
                      v-model="modelAbsence.selectedDocument"
                      :accept="'.pdf'"
                      :attachment-id="modelAbsence.documentId"
                      custom-error-msg="El documento es requerido."
                      display-style="normal"
                      :error="errors[0]"
                      label-position="left"
                      :on-download="onDownloadAbsenceDocument"
                      required
                      @after-remove="
                        () => {
                          modelAbsence.file = null;
                          modelAbsence.documentId = null;
                        }
                      "
                      @input="() => {}"
                    />
                  </validation-provider>
                </div>
                <div class="col-md-12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-text-area
                      v-if="showIfAusencia(modelAbsence)"
                      id="AbcenseComment"
                      v-model="modelAbsence.comment"
                      custom-error-msg="El comentario es requerido."
                      :error="errors[0]"
                      label="Comentario:"
                      :maxlength="3000"
                      placeholder="Escriba un comentario"
                      show-char-count
                    />
                  </validation-provider>
                </div>
              </div>
            </validation-observer>
          </div>
        </div>
        <div v-else class="row header-row">
          <div id="detail-msg" class="col-12">
            <em class="fas fa-info-circle color-orange mr-2" />
            <span class="color-gray-7 font-weight-bold font-14">
              Detalle(s) del registro de la(s) visita(s)
            </span>
          </div>
          <AssistanceDetailsRow
            :is-mobile="isMobile"
            :justification-options="justificationOptions"
            :student-assistance-details="value.visits"
            :visit-type-options="visitTypeAusencia"
            @download-absence-document="onDownloadAbsenceDocument"
            @edit-visit="onEditVisit"
            @save-edition="onSaveEdition"
          />
        </div>
      </template>
    </callout>
    <div v-if="!this.value.isOpen">
      <div
        v-for="error in uniqueErrors"
        :key="error.id"
        class="col-sm-12 visit-errors"
      >
        <div class="pl-1 pt-2">
          <em class="fa fa-times-circle" data-v-1b84b342="" />
          <p class="text-left d-inline ml-1">{{ error.message }}</p>
        </div>
      </div>
    </div>
    <div v-if="!this.value.hasPlan">
      <div class="col-sm-12 visit-errors">
        <div class="pl-1 pt-2">
          <em class="fa fa-times-circle" />
          <p class="text-left d-inline ml-1">
            No cuenta con un plan de intervención en sistema.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Callout from 'custom-callout';
import VueSelect from 'vue-select';
import justifications from '@/utils/constants/visitAbsenceRegistrationTypes.js';
import visitTypes from '@/utils/constants/visitTypes.js';
import documentTypes from '@/utils/constants/documentTypes.js';
import moment from 'moment';
import CustomDropDown from 'custom-drop-down';
import visitAbsenceTypes from '@/utils/constants/visitAbsenceRegistrationTypes.js';
import CustomFileInput from '@/components/common/CustomFileInput';
import AssistanceDetailsRow from './AssistanceDetailsRow.vue';
import { saveSpecialistVisits } from '@/modules/shared/provider.api';
import alertMixin from 'utils/mixins/alert.mixin.js';
import CustomTextArea from '@/components/common/form/CustomTextArea.vue';
import VisitCalendarScheduleUpdate from './VisitCalendarScheduleUpdate.vue';
import calendarViewModes from '@/utils/shared/constants/calendarViewModes';
import ActionButton from 'ActionButton';

export default {
  name: 'VisitStudentRow',
  components: {
    Callout,
    VueSelect,
    CustomDropDown,
    CustomFileInput,
    AssistanceDetailsRow,
    CustomTextArea,
    VisitCalendarScheduleUpdate,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          studentName: null,
          id: null,
          studentSieId: null,
          currentPeriod: null,
          startDate: null,
          endDate: null,
          isOpen: false,
          visits: [],
          hasPlan: null,
          durationId: null,
          modalityId: null,
        };
      },
    },
    monthsPeriodFinalized: {
      type: Array,
      default: () => [],
    },
    types: {
      type: Array,
      default: () => [],
    },
    justificationOptions: {
      type: Array,
      default: () => [],
    },
    hour: {
      type: Object,
      default: () => {
        return {
          hourFrom: null,
          from: null,
          to: null,
          hourTo: null,
        };
      },
    },
    days: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: Date,
      default: () => null,
    },
    endDate: {
      type: Date,
      default: () => null,
    },
    academicYearId: {
      type: Number,
      default: () => null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Number,
      default: calendarViewModes.Week,
    },
  },
  data() {
    return {
      page: {
        data: null,
      },
      originalVisits: [],
      saved: false,
      daysOfWeek: [1, 2, 3, 4, 5, 6, 7],
      uniqueErrors: [],
      showViewErrors: false,
      assistenceType: [
        {
          id: visitTypes.VisitaRegular,
          label: 'Presencial',
          selected: true,
          img: require('@/assets/img/icon_square-p.svg'),
        },
        {
          id: visitTypes.Visita_Ciberterapia,
          label: 'Virtual',
          selected: false,
          img: require('@/assets/img/icon_square-v.svg'),
        },
        {
          id: visitTypes.Ausencia,
          label: 'Ausente',
          selected: false,
          img: require('@/assets/img/icon_square-x.svg'),
        },
      ],
      componentKey: 0,
      modelAbsence: {
        type: null,
        justification: null,
        comment: null,
        selectedDocument: null,
      },
      openAdsencePanel: false,
      currentDayOfWeek: null,
      visitScheduleSelected: null,
      visitErrors: [
        {
          id: 1,
          message:
            'Se identificarón Visita(s) de tipo ausencia que requieren algunos campos.',
        },
        {
          id: 2,
          message:
            'Se identificarón Visita(s) que require documento el cual justifica la ausencia. (0633)',
        },
      ],
    };
  },
  computed: {
    studentRowColor() {
      return this.saved
        ? 'student-callout'
        : !this.value.isOpen && this.isMobile
        ? 'callout__extended'
        : '';
    },
    visitTypeAusencia() {
      return this.types.filter(
        (visit) =>
          visit.id === visitTypes.Ausencia ||
          visit.id == visitTypes.VisitaRegular ||
          visit.id == visitTypes.Visita_Ciberterapia
      );
    },
    showAdsencePanel() {
      return (
        this.modelAbsence.visitTypeId == visitTypes.Ausencia &&
        this.value.isOpen
      );
    },
    requiresDocumentation() {
      return [visitAbsenceTypes.AusenciaJustificadaDelEstudiante].includes(
        this.modelAbsence.justification?.id
      )
        ? true
        : false;
    },
    getVisitScheduleModelToUpdate() {
      return (day) => {
        const visit = this.getVisit(day);
        if (visit?.id) {
          const visitStartMoment = moment(visit.visitDate);
          const visitEndMoment = visitStartMoment.clone();

          const [startHour, startMinutes] = visit.visitTimeStart.split(':');
          visitStartMoment.hours(parseInt(startHour));
          visitStartMoment.minutes(parseInt(startMinutes));

          const [endHour, endMinutes] = visit.visitTimeEnd.split(':');
          visitEndMoment.hours(parseInt(endHour));
          visitEndMoment.minutes(parseInt(endMinutes));
          return {
            id: visit.id,
            type: 0,
            startDate: visitStartMoment.format(),
            endDate: visitEndMoment.format(),
          };
        }

        const schedule = this.getSchedule(day);
        if (schedule)
          return {
            id: schedule.id,
            type: 1,
            startDate: schedule.startDate,
            endDate: schedule.endDate,
          };

        return null;
      };
    },
    showVisitScheduleUpdatedComponent() {
      return (day) => {
        if (!this.visitScheduleSelected || !this.value.hasPlan) return false;
        return (
          this.visitScheduleSelected?.id ===
          this.getVisitScheduleModelToUpdate(day)?.id
        );
      };
    },
    studentSieName() {
      return `${this.value.studentSieId} - ${this.value.studentName}`;
    },
  },
  watch: {
    value() {
      this.value.isOpen = false;
      this.saved = false;
      this.uniqueErrors = [];
      this.showViewErrors = false;
      this.loadSchedulesToVisit();
      this.setVisitToModelAbsense();
    },
    types() {
      this.modelAbsence.type = this.visitTypeAusencia[0];
    },
    modelAbsence: {
      handler() {
        this.saveAbsenceCurrentDay(this.currentDayOfWeek);
      },
      deep: true,
    },
  },
  async created() {
    this.value.selected = this.assistenceType[0];
    this.loadSchedulesToVisit();
    this.setVisitToModelAbsense();
    this.handlerHideArrowWhenIsMobile();
  },
  methods: {
    async verifyValidate() {
      this.value.visits.forEach((visit) => {
        let hasErrors = false;
        this.showViewErrors = false;
        if (!Array.isArray(visit['errors'])) {
          visit['errors'] = [];
        }
        if (visit.visitTypeId == visitTypes.Ausencia) {
          if (!visit.modelAbsence) {
            const visitPending = this.visitErrors[0];
            if (!visit['errors'].some((f) => f.id == 1)) {
              visit['errors'].push(visitPending);
            }
            return;
          }
          if (
            !visit.modelAbsence.comment ||
            !visit.modelAbsence.justification
          ) {
            const visitPending = this.visitErrors[0];
            if (!visit['errors'].some((f) => f.id == 1)) {
              visit['errors'].push(visitPending);
            }
            hasErrors = true;
          } else {
            visit['errors'] = visit['errors'].filter((f) => f.id != 1);
          }

          if (
            visit.modelAbsence &&
            visit.modelAbsence.justification &&
            visit.modelAbsence.justification.id ==
              justifications.AusenciaJustificadaDelEstudiante &&
            !visit.modelAbsence.selectedDocument &&
            !visit.modelAbsence.documentId
          ) {
            const visitPending = this.visitErrors[1];
            hasErrors = true;
            if (!visit['errors'].some((f) => f.id == 2)) {
              visit['errors'].push(visitPending);
            }
          } else {
            visit['errors'] = visit['errors'].filter((f) => f.id != 2);
          }
          if (!hasErrors) {
            visit['errors'] = [];
          }
        } else {
          visit['errors'] = [];
        }
      });
      this.uniqueErrors = [];
      for (const visit of this.value.visits) {
        if (Array.isArray(visit.errors)) {
          for (const error of visit.errors) {
            if (!this.uniqueErrors.some((f) => f.id == error.id)) {
              this.uniqueErrors.push(error);
            }
          }
        }
      }
      if (this.uniqueErrors.length > 0) {
        this.showViewErrors = true;
      }
    },
    validateIsSaved() {
      this.saved = true;

      const savedVisits = this.value?.visits?.filter((x) => x.id > 0) ?? [];
      if (savedVisits.length > 0) return true;

      this.changeViewMode().forEach((day) => {
        if (this.disableDay(day)) {
          return null;
        }

        const visitData = this.getVisit(day);
        if (!visitData || !visitData.id) {
          this.saved = false;
        } else {
          const exist = this.originalVisits.find((x) => x.id == visitData.id);
          if (exist.visitTypeId != visitData.visitTypeId) {
            this.saved = false;
          } else if (
            visitData.visitTypeId == visitTypes.Ausencia &&
            visitData.edited
          ) {
            this.saved = false;
          }
        }
      });
    },
    showDetail() {
      this.$emit('close-all-details', this.value);
      this.value.isOpen = !this.value.isOpen;
      this.openAdsencePanel = false;
      this.verifyValidate();
      this.$forceUpdate();
    },
    showErrors() {
      this.value.isOpen = true;
      this.verifyValidate();
      this.openAdsencePanel = false;
      this.$forceUpdate();
    },
    getVisitType(day) {
      const visitData = this.getVisit(day);
      if (visitData) return visitData.visitTypeId;

      const schedule = this.getSchedule(day);
      return schedule ? visitTypes.VisitaRegular : null;
    },
    visitScheduleUpdated(day) {
      const visit = this.getVisit(day);
      return visit?.visitScheduleUpdated;
    },
    getVisit(day) {
      if (day === 7) day = 0; // 0 = Sunday
      const visit = this.value.visits.find((x) => x.visitDayOfWeek === day);

      return visit;
    },
    getSchedule(day) {
      const fromHour = parseInt(this.hour.from.split(':')[0], 10);
      const toHour = parseInt(this.hour.to.split(':')[0], 10);

      const currentDate = this.days.find((x) => x.id === day);
      const schedule = this.value.schedules.find(
        (x) =>
          x.day == day &&
          moment()
            .set('date', currentDate.dayNumber)
            .set('month', currentDate.month) >=
            moment(this.value.effectiveDateFrom) &&
          moment(
            moment()
              .set('hour', moment(x.startDate).hours())
              .set('minute', moment(x.startDate).minutes())
              .set('second', 0)
              .set('month', currentDate.month)
              .set('date', currentDate.dayNumber)
          ).isBetween(
            moment()
              .set('minute', 0)
              .set('hour', fromHour)
              .set('second', 0)
              .set('month', currentDate.month)
              .set('date', currentDate.dayNumber),
            moment()
              .set('minute', 0)
              .set('hour', toHour)
              .set('second', 0)
              .set('month', currentDate.month)
              .set('date', currentDate.dayNumber),
            undefined,
            '[)'
          )
      );
      return schedule;
    },
    showVisitScheduleUpdatedIcon(day) {
      if (this.getVisit(day)) return true;
      if (this.getSchedule(day)) return true;
      return false;
    },
    async loadSchedulesToVisit() {
      this.originalVisits = JSON.parse(JSON.stringify(this.value.visits));
      this.value.schedules.forEach((schedule) => {
        let getDate = this.getDateForDayOfWeek(
          this.startDate,
          this.endDate,
          schedule.day
        );
        const exist = this.value.visits.find(
          (f) => f.visitDayOfWeek == schedule.day
        );
        if (!exist) {
          let fromDate = moment(schedule.startDate);
          let toDate = moment(schedule.endDate);
          this.value.visits.push({
            visitDayOfWeek: schedule.day,
            visitTypeId: visitTypes.VisitaRegular,
            visitDate:
              getDate != null
                ? moment(getDate).format('YYYY-MM-DD HH:mm')
                : null,
            visitTimeStart: fromDate.format('HH:mm'),
            visitTimeEnd: toDate.format('HH:mm'),
          });
        }
      });
      this.validateIsSaved();
    },
    setVisitToModelAbsense() {
      this.value.visits.forEach((visit) => {
        if (visit.absenceReasonId && visit.absenceReasonName && visit.comment) {
          visit['modelAbsence'] = {
            type: this.types.filter((f) => f.id == visitTypes.Ausencia)[0],
            justification: visit['absenceReasonId']
              ? this.justificationOptions.filter(
                  (f) => f.id == visit.absenceReasonId
                )[0]
              : null,
            comment: visit['comment'] ? visit['comment'] : null,
            selectedDocument: null,
            documentId: visit['documentId'] ? visit['documentId'] : null,
          };
        }
      });
    },
    async setVisitType(day, input) {
      this.visitScheduleSelected = null;

      let getDate = this.getDateForDayOfWeek(this.startDate, this.endDate, day);
      const index = this.value.visits.findIndex(
        (item) => item.visitDayOfWeek === day
      );

      if (index !== -1) {
        this.value.visits[index].visitTypeId = input.id;
      } else {
        let schedule = this.value.schedules.find((schedule) => {
          const startHour = parseInt(moment(schedule.startDate).format('HH'));
          return startHour === this.hour.hourFrom;
        });

        let fromDate = moment(schedule.startDate);
        let toDate = moment(schedule.endDate);

        this.value.visits.push({
          visitDayOfWeek: day,
          visitTypeId: input.id,
          visitDate: moment(getDate).format('YYYY-MM-DD HH:mm'),
          visitTimeStart: fromDate.format('HH:mm'),
          visitTimeEnd: toDate.format('HH:mm'),
        });
      }
      this.modelAbsence = {
        type: null,
        justification: null,
        comment: null,
        selectedDocument: null,
      };
      this.componentKey++;
      this.currentDayOfWeek = day;

      if (input.id != visitTypes.Ausencia) {
        this.verifyValidate();
        this.$forceUpdate();
      }

      this.saved = false;

      this.handleOpenPanels(input.id);
      this.validateIsSaved();
    },
    getAssistenceTypeItem(value) {
      return this.assistenceType.find((f) => f.id === value);
    },
    async saveVisit(skipExecution = false) {
      if (skipExecution) return;
      let isValid = true;
      if (this.$refs.formAbsense) {
        isValid = await this.$refs.formAbsense.validate();
      }
      this.verifyValidate();
      if (!isValid || this.showViewErrors) {
        return;
      }
      this.showViewErrors = false;
      this.value.academicYearId = this.academicYearId;
      this.value.startDate = this.startDate;
      this.value.endDate = this.endDate;
      this.value.visits.forEach((a) => {
        if (a.modelAbsence) {
          if (a.modelAbsence.justification) {
            a.absence = {};
            a.absence.justiticationId = a.modelAbsence.justification.id;
            a.absence.typeId = a.modelAbsence.type.id;
            a.absence.file = a.modelAbsence.selectedDocument;
            a.absence.comment = a.modelAbsence.comment;
          }
        }
      });

      let obj = {
        academicYearId: this.value.academicYearId,
        admissionId: this.value.admissionId,
        endDate: this.value.endDate,
        id: this.value.id,
        impedimentName: this.value.impedimentName,
        startDate: this.value.startDate,
        studentName: this.value.studentName,
        studentSieId: this.value.studentSieId,
        visits: this.value.visits,
        modalityId: this.value.modalityId,
        durationId: this.value.durationId,
      };

      let formData = new FormData();
      formData.append('academicYearId', obj.academicYearId);
      formData.append('admissionId', obj.admissionId);
      formData.append('endDate', obj.endDate);
      formData.append('id', obj.id);
      formData.append('impedimentName', obj.impedimentName);
      formData.append('startDate', obj.startDate.toString());
      formData.append('studentName', obj.studentName);
      formData.append('studentSieId', obj.studentSieId);
      formData.append('durationId', obj.durationId);
      formData.append('modalityId', obj.modalityId);
      obj.visits.forEach((visit, index) => {
        formData.append(`visits[${index}].id`, visit.id);
        formData.append(`visits[${index}].visitTypeId`, visit.visitTypeId);
        formData.append(
          `visits[${index}].visitDate`,
          visit.visitDate.toString()
        );
        if (visit.visitTimeStart) {
          formData.append(
            `visits[${index}].visitTimeStart`,
            visit.visitTimeStart
          );
          formData.append(`visits[${index}].visitTimeEnd`, visit.visitTimeEnd);
        }
        if (visit.absence) {
          formData.append(
            `visits[${index}].absence.justiticationId`,
            visit.absence.justiticationId
          );
          if (
            visit.absence.justiticationId ==
            justifications.AusenciaJustificadaDelEstudiante
          ) {
            formData.append(
              `visits[${index}].absence.documentTypeId`,
              documentTypes.JustificacionAusencia
            );
          }
          formData.append(
            `visits[${index}].absence.typeId`,
            visit.absence.typeId
          );
          formData.append(`visits[${index}].absence.file`, visit.absence.file);
          formData.append(
            `visits[${index}].absence.comment`,
            visit.absence.comment
          );
        }
      });

      await saveSpecialistVisits(formData).then((response) => {
        this.saved = true;
        this.value.visits.forEach((visit) => {
          let modifiedVisit = response.data.visits.find(
            (f) =>
              f.visitTypeId == visit.visitTypeId &&
              moment(f.visitDate).isSame(moment(visit.visitDate))
          );
          if (modifiedVisit) {
            visit['id'] = modifiedVisit.id;
            if (modifiedVisit.absence) {
              visit['documentId'] = modifiedVisit.absence.documentId;
              visit['documentType'] = modifiedVisit.absence.documentTypeId;
              visit['documentTypeName'] = 'Justificación de Ausencia';
              visit['comment'] = modifiedVisit.absence.comment;
              visit.modelAbsence['documentId'] =
                modifiedVisit.absence.documentId;
              visit['absenceReasonId'] = modifiedVisit.absence.justiticationId;
            }
          }
        });
        this.openAdsencePanel = false;
        this.value.isOpen = false;
        this.modelAbsence = {
          justification: null,
          comment: null,
          selectedDocument: null,
        };
        this.$forceUpdate();
        this.ShowToast(
          'Proceso Exitoso',
          'Las visitas han sido guardadas exitosamente.',
          'success'
        );
      });
    },
    getDateForDayOfWeek(startDate, endDate, targetDayOfWeek) {
      const daysDifference =
        (targetDayOfWeek - moment(startDate).day() + 7) % 7;

      const targetDate = new Date(startDate);
      targetDate.setDate(moment(startDate).date() + daysDifference);

      if (targetDate > endDate) {
        return null;
      }

      return targetDate;
    },
    handleOpenPanels(id) {
      if (id == visitTypes.Ausencia) {
        this.modelAbsence.type = this.types.filter(
          (f) => f.id == visitTypes.Ausencia
        )[0];
        this.value.isOpen = true;
        this.openAdsencePanel = true;
        this.$forceUpdate();
      } else {
        this.value.isOpen = false;
        this.openAdsencePanel = false;
        this.$forceUpdate();
      }
    },
    async saveAbsenceCurrentDay(currentDayOfWeek) {
      const idx = this.value.visits.findIndex(
        (item) => item.visitDayOfWeek === currentDayOfWeek
      );
      if (this.modelAbsence.type) {
        this.value.visits[idx].visitTypeId = this.modelAbsence.type.id;
      }
      if (
        this.modelAbsence.justification ||
        this.modelAbsence.comment ||
        this.modelAbsence.selectedDocument
      ) {
        this.value.visits[idx]['modelAbsence'] = { ...this.modelAbsence };
      }
    },
    onDownloadAbsenceDocument(id) {
      this.$emit('download-absence-document', id);
    },
    onSaveEdition(data) {
      this.$emit('save-edition', data);
    },
    disableDay(day) {
      const getDate = this.getDateForDayOfWeek(
        this.startDate,
        this.endDate,
        day
      );

      const monthNumber = moment(getDate).month() + 1;
      // if there are months finalized then disable
      if (
        this.monthsPeriodFinalized?.length > 0 &&
        // if the month of this visit date is not yet finalized then continue
        this.monthsPeriodFinalized.findIndex(
          (month) => month === monthNumber
        ) !== -1
      )
        return true;

      if (
        getDate > new Date() ||
        getDate < moment(this.value.effectiveDateFrom) ||
        getDate > moment(this.value.effectiveDateTo)
      ) {
        return true;
      } else {
        return !this.value.schedules.some((f) => f.day == day && !f.isDisabled);
      }
    },
    handlerHideArrowWhenIsMobile() {
      if (this.isMobile) {
        Array.from(document.querySelectorAll('.vs__dropdown-toggle')).forEach(
          (e) => {
            const { children } = e;
            if (
              children.length > 0 &&
              children[0]?.children[0]?.tagName == 'SPAN'
            ) {
              children[1].style.display = 'none';
            }
          }
        );
      }
    },
    onCancelScheduleUpdate() {
      this.visitScheduleSelected = null;
    },
    onSaveScheduleUpdate({ visitId, scheduleId, startDate, endDate, day }) {
      this.visitScheduleSelected = null;
      const date = this.getDateForDayOfWeek(this.startDate, this.endDate, day);
      const fromDate = moment(startDate);
      const toDate = moment(endDate);
      const payload = {
        visitId,
        scheduleId,
        date,
        visitTypeId: visitTypes.VisitaRegular,
        academicYearId: this.academicYearId,
        admissionId: this.value.admissionId,
        studentSieId: this.value.studentSieId,
        startDate: fromDate.format('HH:mm'),
        endDate: toDate.format('HH:mm'),
      };

      this.$emit('update-schedule', payload);
    },
    onClickUpdateSchedule(day) {
      this.visitScheduleSelected = this.getVisitScheduleModelToUpdate(day);
    },

    isBool(value) {
      return typeof value === 'boolean';
    },
    onEditVisit(item) {
      this.value.isOpen = true;
      this.openAdsencePanel = true;
      this.modelAbsence.type = this.types.filter(
        (f) => f.id == item.visitTypeId
      )[0];
      const visitIndex = this.value.visits.findIndex(
        (f) =>
          f.visitDay == item.visitDay && f.visitDayOfWeek == item.visitDayOfWeek
      );
      this.currentDayOfWeek = item.visitDayOfWeek;
      let currentVisit = this.value.visits[visitIndex];
      currentVisit.edited = true;
      if (currentVisit['modelAbsence']) {
        this.modelAbsence = currentVisit['modelAbsence'];
      } else {
        this.modelAbsence = {
          type: this.types.filter((f) => f.id == visitTypes.Ausencia)[0],
          justification: currentVisit['absenceReasonId']
            ? this.justificationOptions.filter(
                (f) => f.id == currentVisit.absenceReasonId
              )[0]
            : null,
          comment: currentVisit['comment'] ? currentVisit['comment'] : null,
          selectedDocument: null,
          documentId: currentVisit['documentId']
            ? currentVisit['documentId']
            : null,
        };
      }
      this.$forceUpdate();
      this.validateIsSaved();
    },
    showIfAusencia(item) {
      return item.type.id == visitTypes.Ausencia;
    },
    changeViewMode() {
      const dayWeek = this.getWeekDay();
      let days = this.daysOfWeek;
      if (this.viewMode == calendarViewModes.Day) {
        days = [];
        days.push(dayWeek);
      }
      return days;
    },
    getWeekDay() {
      var numberWeek = moment(this.startDate).day();
      return numberWeek;
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.col-balloon {
  min-width: 265px !important;
}

.col-student {
  align-content: center;
}
.select-assistence {
  min-width: 100px;
}
.header-row {
  padding: 20px 20px 0px 20px;
}
#detail-msg {
  padding-bottom: 8px;
}

.grid-7 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.visit-schedule-updated-icon {
  position: absolute;
  top: 17px;
  z-index: 1;
  left: 26px;
  cursor: pointer;
  color: map-get($colors, 'gray-3');
}
@media (max-width: 767px) {
  ::v-deep .vs__selected-options input {
    padding: 0;
  }
  ::v-deep .vs__selected {
    padding: 0;
  }
}

.margin-dropdown {
  margin-left: -11px;
}
.gradient-toggle-mob {
  display: none;
}
.gradient-toggle {
  display: flex !important;
  background-color: white;
  box-shadow: 5px 0 5px #effff3;
}

.student-callout ::v-deep {
  .gradient-toggle {
    box-shadow: 5px 0 5px #c5f3d1;
  }

  .bg-secondary-3 {
    background-color: #effff3 !important;
  }
}

.callout__extended ::v-deep {
  .far.font-20.fa-chevron-circle-up.color-primary-2 {
    transform: rotate(90deg);
  }
}
.vue-select__extended ::v-deep {
  .vs__actions {
    display: none;
  }
}
.errors-link {
  color: #ff5c5c;
  text-decoration: underline;
  cursor: pointer;
}
.visit-errors {
  background-color: #ffebeb;
  color: #ff5b5c;
  font-size: 15px;
  min-height: 40px;
  border-radius: 0 0 5px 5px;
}
</style>
